export default __webpack_public_path__ + "static/ay-support-content-engineering-7d4fab13af63b17f089fedfef11358a8.svg";